export const localStorage = {
	token: "token",
	reactQueryCache: "reactQueryCache",
};
